/*
 * @Description: 
 * @Version: 
 * @Autor: liutt
 * @Date: 2024-04-26 16:36:59
 * @LastEditors: liutt
 * @LastEditTime: 2024-07-05 17:47:27
 * @FilePath: \Platform_Front\src\platform\components\BubbleTip\index.js
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './index.less';
import { Tooltip as NCTooltip } from '@platform/base';
function getTooltipMsg(msg) {
    if (typeof msg === 'string' && msg.indexOf('\\n') > -1) {
        msg = msg.replaceAll('\\n', '\n');
    }
    return msg;
}

export const BubbleTip = (props) => {
    const [icon, setIcon] = useState('icon-shuoming1');
    const { placement = 'top', className = '', overlay, title = null } = props;
    function renderContent(overlay) {
        let content = getTooltipMsg(overlay);
        return (
            <>
                {title && <div className="assist-title">{title}</div>}
                {content}
            </>
        );
    }
    function onMouseEnter(params) {
        setIcon('icon-shuoming2');
    }
    function onMouseLeave(params) {
        setIcon('icon-shuoming1');
    }
    return (
        <NCTooltip
            placement={placement}
            className={`assist-wrap ${className}`}
            overlay={renderContent(overlay)}
            // delayShow={1}
        >
            <i className={`iconfont help-icon ${icon}`} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} />
        </NCTooltip >
    );
}

BubbleTip.propTypes = {
    placement: PropTypes.string, // 气泡框位置： top/left/right/bottom
    className: PropTypes.string, // 自定义气泡样式
    title: PropTypes.string, // 气泡框标题
    overlay: PropTypes.oneOfType([PropTypes.string, PropTypes.node]) // 气泡框内容
};
